var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.userInfo)?_c('div',{staticClass:"UserSpecificInformation",attrs:{"id":"lLJDLFDASJ"}},[_c('p',[_vm._v(_vm._s(_vm.userInfo.userName)+" "+_vm._s(_vm.userInfo.userSex)+" "+_vm._s(_vm.userInfo.userAge)+"岁")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }